module.exports = __webpack_public_path__ + "img/info-01.a0b21653.jpg";